<template>
    <div :class="classes">
        <b-button v-if="!show"
            :variant="buttonVariant"
            :class="buttonClasses"
            @click="$emit('openClick')"
        >
            {{ buttonLabel }}    
        </b-button>
        <b-list-group v-else
            horizontal 
            :class="['shadow-uniform', listGroupClasses]"
        >
            <b-list-group-item 
                v-for="value in values" 
                :key="value.id" 
                class="border-right-0 p-2 m-0"
            >
                <b-button 
                    :id="`tooltip-button-${identity}-${value.id}`"
                    :class="['bg-white border-0 shadow-none p-0', valueButtonClasses, {'active': selected === value.id}]"
                    @click="$emit('selectClick', value.id)"
                >
                    {{value.label}}
                </b-button>
                <b-tooltip v-if="tooltip"
                    :target="`tooltip-button-${identity}-${value.id}`"
                >
                    {{value.tooltip}}
                </b-tooltip>
            </b-list-group-item>
            <b-list-group-item v-if="deleteEnable"
                class="p-1 m-0"
            >
                <b-button 
                    :id="`tooltip-button-${identity}-close`"
                    :class="['bg-white border-0 shadow-none p-0', valueButtonClasses]"
                    @click="$emit('closeClick')"
                >                
                    <b-icon 
                        icon="x" 
                        font-scale="1.75" 
                        variant="secondary" 
                    />
                </b-button>
                <b-tooltip v-if="tooltip"
                    :target="`tooltip-button-${identity}-close`"
                >
                    {{deleteTooltip}}
                </b-tooltip>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
    export default {
        name: "ListGroup",
        props: {
            identity: Number,
            classes: String,
            buttonLabel: {
                type: String,
                required: true
            },
            buttonVariant: String,
            buttonClasses: String | Array,
            show: Boolean,
            values: {
                type: Array,
                required: true
            },
            listGroupClasses: String,
            valueButtonClasses: String,
            selected: Number,
            tooltip: Boolean,
            deleteEnable: Boolean,
            deleteTooltip: String
        }
    }
</script>

<style scoped lang="scss">
    .list-group {
        line-height: 1;
        button.emotion-icon {
            line-height: 1.3;
            &:hover, &.active {
                transform:scale(1.3,1.3);
                -webkit-transform:scale(1.3,1.3);
                -moz-transform:scale(1.3,1.3);
            }
        }
    }
</style>